export default __webpack_public_path__ + "static/media/dot_flexible.fee3ce80.svg";